import React, { useEffect, useState } from 'react';
import {toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

import axios from 'axios';
import Navbar from '../../Navbar';


const TicketList = () => {
  const [tickets, setTickets] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch ticket data
    axios.get('/ticketDetails/api/v1/api/getalltickets')
      .then((response) => setTickets(response.data))
      .catch((error) => console.error("There was an error fetching the tickets!", error));
  }, []);

  return (
  <>
 <div className="">
    <Navbar />
</div>
    <div className='d-flex justify-content-center align-items-left bg-white vh-100 mt-5'>
    
    <div className='bg-secondary p-3 rounded w-75'>
    
    <h4 className='text-center'>Ticket List</h4>
    <div className='mb-3 bg-white text-black text-left form-control-sm rounded-3'>
    
      
      <ul className='text-left'>
      <li className='bg-black'>
            <a className='m-1'>Change Ticket Status |</a>            
            <a className='m-1'>Change Asigned Person |</a>
            <a className='m-1'>Title |</a>
            <a className='m-1'>Description |</a>
            <a className='m-1'>Status</a>
          </li>
        {tickets.map(ticket => (
          <li key={ticket.id}>
            <a className='m-1' href={`/ticket/${ticket.id}`}>Change Ticket Status |</a>            
            <a className='m-1' href={`/ticket/${ticket.id}`}>Change Asigned Person |</a>
            <a className='m-1'>{ticket.title} |</a>
            <a className='m-1'>{ticket.description} |</a>
            <a className='m-1'>{ticket.status}</a>
          </li>
        ))}
      </ul>
    </div>
    </div>
    </div>
    </>
  );
}

export default TicketList;
